import { createReducer } from "@reduxjs/toolkit";
import { educationalAdvisorRetrievePendingActions } from "./retrieve-pending-actions";
import type { EducationalAdvisorPendingActionsVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<EducationalAdvisorPendingActionsVM> = {
  fetching: "idle",
  data: {
    hasActions: false,
    evaluations: { pendingCount: 0 },
    batches: { pendingCount: 0 },
  },
};

export const educationalAdvisorPendingActionsRetrievalReducer = createReducer<RetrievalState<EducationalAdvisorPendingActionsVM>>(
  initialState,
  builder => {
    builder.addCase(educationalAdvisorRetrievePendingActions.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    });
    builder.addCase(educationalAdvisorRetrievePendingActions.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    });
    builder.addCase(educationalAdvisorRetrievePendingActions.rejected, state => {
      return {
        ...state,
        fetching: "failed",
      };
    });
  },
);
